<div class="is-overlay popup-overlay">
</div>

<div class="popup" [@inOutAnimation]>
  <div class="popup-body">
    <app-modal-body class="is-flex-direction-column items-align-center">
      <app-icon
        name="info"
        class="text-yellow text-32 is-large has-spacing-bottom-xxs">
      </app-icon>
      <ng-content class="content" select="[role=content]"></ng-content>
    </app-modal-body>
    <app-modal-footer class="popup-footer bg-grey-hover-10 is-fullwidth">
      <ng-content select="[role=footer]"></ng-content>
    </app-modal-footer>  
  </div> 
</div>

